<template>
    <div class="live">
      <IndexPage ></IndexPage>
      <el-row class="tac">
        <el-col :span="4">
          <el-menu default-active="1"  class="el-menu-vertical-demo" @select="findItem">
            <template >
                <el-menu-item v-for="(menu, i) in menuInfo" :key="(i+1)" :index="menu.id + ''">
                        <i class="el-icon-menu"></i>
                        <span>{{menu.time}}</span>
                </el-menu-item>
            </template>
          </el-menu>
        </el-col>
      <el-col :span="18">
        <div style="margin-top:5%;margin-left:10%">
          <el-card shadow="always" v-if="selectLiveId!=''">
              <el-table
                :data="items"
                :max-height="tableHight"
                style="width: 100%">
                <el-table-column
                  label="序号"
                  type="index">
                </el-table-column>

                <!-- <el-table-column
                  label="商品 ID"
                  prop="id"
                  width="auto"
                  min-width="8%">
                </el-table-column> -->

                <el-table-column
                  label="品牌名称"
                  prop="brand"
                  width="auto"
                  min-width="20%">
                </el-table-column>

                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                      <el-form-item label="品牌名称" v-if="props.row.brand">
                        <span>{{ props.row.brand }}</span>
                      </el-form-item>
                      <el-form-item label="商品名称" v-if="props.row.name">
                        <span>{{ props.row.name }}</span>
                      </el-form-item>
                      <el-form-item label="所属店铺" v-if="props.row.shop">
                        <span>{{ props.row.shop }}</span>
                      </el-form-item>
                      <el-form-item label="商品属性" v-if="props.row.properties">
                        <span>{{ props.row.properties }}</span>
                      </el-form-item>
                      <el-form-item label="商品规格" v-if="props.row.specs">
                        <span>{{ props.row.specs }}</span>
                      </el-form-item>
                      <el-form-item label="商品位置" v-if="props.row.location">
                        <span>{{ props.row.location }}</span>
                      </el-form-item>
                      <el-form-item label="直播价" v-if="props.row.lowPrice">
                        <span>{{ props.row.lowPrice }}</span>
                      </el-form-item>
                      <el-form-item label="商品已拥有" v-if="props.row.hasString">
                        <span>{{ props.row.hasString }}</span>
                      </el-form-item>
                      <el-form-item label="商品描述" v-if="props.row.description">
                        <span>{{ props.row.description }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  width="auto"
                  min-width="38%"
                  prop="name">
                </el-table-column>
                <el-table-column
                  label="属性"
                  prop="properties"
                  width="auto"
                  min-width="20%">
                </el-table-column>
                <!-- <el-table-column
                  label="描述"
                  prop="desc">
                </el-table-column> -->
                <el-table-column label="操作"  width="auto" min-width="22%">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      @click="show(scope.$index, scope.row)">查看</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="handleMoveFromLive( scope.$index, scope.row)">移除直播</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
            <!-- margin-top:5%;margin-left:30%;margin-right:30% ; -->
            <div style=" left:50% ;bottom: 5%; position:fixed">
              <el-button
                      type="primary"
                      @click='dialogFormVisible = true'>创建直播</el-button>
                    <el-button
                      type="danger"
                      @click="handlBeforeMoveLive">删除直播</el-button>
            </div>
        </div>
      </el-col>
      </el-row>

      <el-dialog title="选择创建的直播日期" :visible.sync="dialogFormVisible">
        <el-date-picker v-model="creatLiveTime" type="date" placeholder="选择日期" style="width:80%"> </el-date-picker>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="creatLive">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import Common from './Common'
export default {
  name: 'Live',
  data () {
    return {
      tableHight: window.innerHeight * 0.65,
      dialogFormVisible: false,
      creatLiveTime: '',
      selectLiveId: '',
      selectLiveTime: '',
      menuInfo: [],
      items: []
    }
  },
  mounted () {
    this.getAllLives()
  },
  methods: {
    show (index, row) {
      const routeUrl = this.$router.resolve({
        path: '/show',
        query: {
          id: row.id
        }
      })
      window.open(routeUrl.href, '_blank')
      console.log(row.id)
    },
    findItem (key, keyPath) {
      this.selectLiveId = key
      for (var i in this.menuInfo) {
        if (this.menuInfo[i].id === this.selectLiveId) {
          this.selectLiveTime = this.menuInfo[i].time
        }
      }
      this.$axios.get(Common.baseUrl + 'liveHasGoods/findItem', {params: {liveId: key}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.items = res.data.data
          for (let i in this.items) {
            let hasList = this.items[i].has
            this.items[i].hasString = hasList.join(' · ')
          }
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    getAllLives () {
      this.$axios.get(Common.baseUrl + 'lives/getAllLives'
      ).then((res) => {
        let code = res.data.code
        this.menuInfo = []
        if (code === 200) {
          for (var i in res.data.data) {
            let s = res.data.data[i].time
            let time = s.substring(0, s.indexOf(' '))
            let live = {id: res.data.data[i].id, time: time}
            this.menuInfo.push(live)
          }
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    creatLive () {
      if (this.creatLiveTime === '') {
        this.$message({
          message: '请输入时间',
          type: 'warning'
        })
        return
      }
      this.$axios.post(Common.baseUrl + 'lives/creatLive', this.creatLiveTime
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.menuInfo = []
          console.log(res.data.data)
          for (var i in res.data.data) {
            let s = res.data.data[i].time
            let time = s.substring(0, s.indexOf(' '))
            let live = {id: res.data.data[i].id, time: time}
            this.menuInfo.push(live)
          }
          this.dialogFormVisible = false
          this.$message({
            message: '创建直播成功！',
            type: 'success'
          })
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handleMoveFromLive (index, row) {
      this.$axios.get(Common.baseUrl + 'liveHasGoods/delete', {params: {liveId: this.selectLiveId, itemId: row.id}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.items.splice(index, 1)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handleMoveLive () {
      if (this.selectLiveId === '') {
        this.$message({
          message: '请重新选择直播场次',
          type: 'warning'
        })
        return
      }
      this.$axios.get(Common.baseUrl + 'lives/deleteById', {params: {liveId: this.selectLiveId}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '删除成功！',
            type: 'success'
          })
          for (var i in this.menuInfo) {
            if (this.menuInfo[i].id === this.selectLiveId) {
              this.menuInfo.splice(i, 1)
            }
          }
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handlBeforeMoveLive () {
      this.$confirm('是否删除' + this.selectLiveTime + '直播?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleMoveLive()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Live.vue